var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductPageInfo3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1750 3045.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e74f59;}.cls-2{fill:#fff;}.cls-3{stroke-width:15.67px;}.cls-3,.cls-4,.cls-5{stroke:#312936;}.cls-3,.cls-4,.cls-5,.cls-6{fill:none;stroke-miterlimit:10;}.cls-7{opacity:.33;}.cls-8{fill:#c9c9c9;}.cls-4{stroke-width:22.02px;}.cls-9{fill:#a0a0a0;opacity:.25;}.cls-10{fill:#e68864;}.cls-11{clip-path:url(#clippath);}.cls-5{stroke-width:15px;}.cls-12{fill:#edc679;}.cls-13{fill:#312936;}.cls-6{stroke:#2d2d2d;stroke-width:7.1px;}.cls-14{opacity:.71;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 602.27,
    cy: 454.15,
    rx: 454.01,
    ry: 454.02
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Object"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "601.73 2420.18 601.73 908.29 1137.59 908.29 1137.59 2420.18 1500 2420.18 875 3045.18 250 2420.18 601.73 2420.18"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "987.37 908.29 1174.22 908.29 1174.22 846.62 1194.82 846.62 1194.82 813.9 1174.22 813.9 1174.22 715.72 1144.73 715.72 1144.66 682.99 1174.22 682.99 1174.22 552.09 1161.86 552.09 1161.86 490.42 975.01 490.42 975.01 552.09 987.37 552.09 987.37 682.99 958.54 682.99 958.54 715.72 987.37 715.72 987.37 813.9 1007.97 813.9 1007.97 846.62 987.37 846.62 987.37 908.29"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1174.22,
    y1: 879.35,
    x2: 987.37,
    y2: 879.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1194.82,
    y1: 846.62,
    x2: 987.37,
    y2: 846.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1194.82,
    y1: 813.9,
    x2: 987.37,
    y2: 813.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1174.22,
    y1: 781.17,
    x2: 987.37,
    y2: 781.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1174.22,
    y1: 748.44,
    x2: 987.37,
    y2: 748.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1174.22,
    y1: 715.72,
    x2: 958.54,
    y2: 715.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1174.22,
    y1: 682.99,
    x2: 958.54,
    y2: 682.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1174.22,
    y1: 650.27,
    x2: 987.37,
    y2: 650.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1174.22,
    y1: 617.54,
    x2: 987.37,
    y2: 617.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1174.22,
    y1: 584.82,
    x2: 987.37,
    y2: 584.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1174.22,
    y1: 552.09,
    x2: 975.01,
    y2: 552.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1161.82,
    y1: 519.37,
    x2: 974.97,
    y2: 519.37
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1415.01,
    y: 781.17,
    width: 186.85,
    height: 127.12,
    transform: "translate(3016.87 1689.46) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1601.86,
    y1: 879.35,
    x2: 1415.01,
    y2: 879.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1601.86,
    y1: 846.62,
    x2: 1415.01,
    y2: 846.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1601.86,
    y1: 813.9,
    x2: 1415.01,
    y2: 813.9
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1290.68,
    y: 682.99,
    width: 186.85,
    height: 225.3,
    transform: "translate(2768.21 1591.28) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1382.74,
    y: 682.99,
    width: 26.42,
    height: 225.3,
    transform: "translate(2791.89 1591.28) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1441.32,
    y: 682.99,
    width: 13.21,
    height: 225.3,
    transform: "translate(2895.84 1591.28) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1477.53,
    y1: 879.35,
    x2: 1290.68,
    y2: 879.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1477.53,
    y1: 846.62,
    x2: 1290.68,
    y2: 846.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1477.53,
    y1: 813.9,
    x2: 1290.68,
    y2: 813.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1477.53,
    y1: 781.17,
    x2: 1290.68,
    y2: 781.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1477.53,
    y1: 748.44,
    x2: 1290.68,
    y2: 748.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1477.53,
    y1: 715.72,
    x2: 1290.68,
    y2: 715.72
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1477.53,
    y: 781.17,
    width: 15.45,
    height: 127.12,
    transform: "translate(2970.51 1689.46) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 602.27,
    cy: 454.15,
    rx: 454.01,
    ry: 454.02
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 125.68,
    y1: 54.57,
    x2: 1131.12,
    y2: 54.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 125.68,
    y1: 127.22,
    x2: 1131.12,
    y2: 127.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 125.68,
    y1: 199.87,
    x2: 1131.12,
    y2: 199.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 125.68,
    y1: 272.52,
    x2: 1131.12,
    y2: 272.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 125.68,
    y1: 345.17,
    x2: 1131.12,
    y2: 345.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 125.68,
    y1: 417.82,
    x2: 1131.12,
    y2: 417.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 125.68,
    y1: 490.47,
    x2: 1131.12,
    y2: 490.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 125.68,
    y1: 563.12,
    x2: 1131.12,
    y2: 563.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 125.68,
    y1: 635.77,
    x2: 1131.12,
    y2: 635.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 125.68,
    y1: 708.42,
    x2: 1131.12,
    y2: 708.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 125.68,
    y1: 781.07,
    x2: 1131.12,
    y2: 781.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 125.68,
    y1: 853.72,
    x2: 1131.12,
    y2: 853.72
  })))), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 701.14,
    cy: 454.15,
    rx: 454.01,
    ry: 454.02
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 701.93,
    cy: 454.15,
    rx: 387.3,
    ry: 387.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m679.38,695.71v-46.24c-46.62-1.81-82.65-14.28-108.13-37.4-25.49-23.13-38.4-55.09-38.77-95.89h100.11c1.09,20.67,5.17,35.55,12.24,44.61,7.07,9.07,17.95,13.87,32.64,14.41l.27-89.77c-49.33-10.88-84.97-25.8-106.91-44.75-21.94-18.95-32.91-44.12-32.91-75.49,0-34.82,13.11-62.88,39.31-84.19,26.21-21.31,61.51-32.42,105.96-33.32v-35.1h43.52v34.56c42.44,1.09,75.53,12.01,99.29,32.78,23.75,20.76,36.36,49.74,37.82,86.91h-95.21c-.91-15.96-4.94-28.12-12.11-36.46-7.17-8.34-17.45-12.68-30.87-13.06v82.42c52.41,12.51,89.54,28.52,111.39,48.01,21.86,19.49,32.79,45.84,32.79,79.03,0,38.44-12.38,67.87-37.13,88.27-24.76,20.4-61.98,32.05-111.68,34.95v45.7h-41.61Zm6.52-305.48v-73.99h-2.17c-15.78,0-27.61,2.99-35.51,8.97-7.88,5.98-11.82,15.05-11.82,27.21,0,9.25,3.67,16.72,11.01,22.44,7.34,5.71,20.18,10.84,38.49,15.38Zm32.38,184.97c17.41,0,30.6-3.08,39.57-9.25,8.98-6.16,13.46-15.31,13.46-27.47,0-10.52-3.8-18.91-11.42-25.16-7.61-6.25-21.48-12.2-41.61-17.82v79.7Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1132.31,
    y: 766.04,
    width: 227.45,
    height: 142.25,
    rx: 7.85,
    ry: 7.85
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1132.31,
    y: 796.59,
    width: 227.45,
    height: 25.74
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1291.55,
    y: 837.17,
    width: 47.28,
    height: 32.36,
    rx: 4.06,
    ry: 4.06
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1149.88,
    y: 837.17,
    width: 86.49,
    height: 9.72,
    rx: 4.06,
    ry: 4.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1149.88,
    y: 857.05,
    width: 24.85,
    height: 9.72,
    rx: 4.06,
    ry: 4.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1185.17,
    y: 857.05,
    width: 24.85,
    height: 9.72,
    rx: 4.06,
    ry: 4.06
  })))))), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    y1: 908.29,
    x2: 1750,
    y2: 908.29
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductPageInfo3);
export default __webpack_public_path__ + "static/media/product-page-info-3.8e2306690f23bc1fa310f1bb08bd8cd0.svg";
export { ForwardRef as ReactComponent };